const KEY = "styx-post-sw-reload";

/** После reload второй заход — без полной матрицы шагов. */
let postSwRestartActive = false;

export function markPostSwReloadPending(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* private mode */
  }
}

/** Однократно в начале registerPwaForBootScreen; выставляет флаг для компактного boot. */
export function consumePostSwReloadFromSession(): boolean {
  try {
    if (sessionStorage.getItem(KEY) !== "1") return false;
    sessionStorage.removeItem(KEY);
    postSwRestartActive = true;
    return true;
  } catch {
    return false;
  }
}

export function isPostSwRestartBoot(): boolean {
  return postSwRestartActive;
}

export function clearPostSwRestartBoot(): void {
  postSwRestartActive = false;
}
